/* YOOME header and mega-menu interactions */
(function () {
  'use strict';

  function initHeader(header) {
    if (!header || header.dataset.yoomeHeaderReady === 'true') return;
    header.dataset.yoomeHeaderReady = 'true';

    var items = Array.from(header.querySelectorAll('[data-yoome-nav-item]'));
    var closeTimer = null;

    // Safety net: only the link for the page you are actually on stays highlighted.
    // Placeholder urls (#, empty) and parent triggers never keep the active state.
    function syncActiveState() {
      var here = window.location.pathname.replace(/\/+$/, '') || '/';
      header.querySelectorAll('.yoome-nav__link').forEach(function (link) {
        var href = link.getAttribute('href');
        var path = null;
        if (href && href !== '#') {
          try { path = new URL(href, window.location.origin).pathname.replace(/\/+$/, '') || '/'; }
          catch (e) { path = null; }
        }
        var current = path !== null && path === here;
        link.classList.toggle('is-active', current);
        if (current) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    }

    syncActiveState();

    function closeItem(item) {
      if (!item) return;
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) closeItem(item);
      });
    }

    function openItem(item) {
      if (!item || !item.querySelector('[data-mega-panel]')) return;
      window.clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
      var trigger = item.querySelector('[data-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose(item) {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () { closeItem(item); }, 140);
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-mega-trigger]');
      var panel = item.querySelector('[data-mega-panel]');
      if (!trigger || !panel) return;

      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'touch') openItem(item);
      });

      item.addEventListener('pointerleave', function (event) {
        if (event.pointerType !== 'touch') scheduleClose(item);
      });

      item.addEventListener('focusin', function () { openItem(item); });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) scheduleClose(item);
      });

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (item.classList.contains('is-open')) closeItem(item);
        else openItem(item);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          openItem(item);
          var firstLink = panel.querySelector('a');
          if (firstLink) firstLink.focus();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!header.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll();
        var expanded = header.querySelector('[data-mega-trigger][aria-expanded="true"]');
        if (expanded) expanded.focus();
      }
    });
  }

  function initMobileMenu() {
    var toggle = document.getElementById('MobileMenuToggle');
    var close = document.getElementById('MobileMenuClose');
    var menu = document.getElementById('MobileMenu');
    var overlay = document.getElementById('MobileMenuOverlay');
    if (!toggle || !menu || !overlay || toggle.dataset.yoomeMobileReady === 'true') return;
    toggle.dataset.yoomeMobileReady = 'true';

    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      overlay.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        var firstFocusable = menu.querySelector('button, a, summary');
        if (firstFocusable) window.setTimeout(function () { firstFocusable.focus(); }, 50);
      }
    }

    toggle.addEventListener('click', function () { setOpen(true); });
    if (close) close.addEventListener('click', function () { setOpen(false); });
    overlay.addEventListener('click', function () { setOpen(false); });

    menu.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (link) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  function init(scope) {
    var context = scope || document;
    var header = context.matches && context.matches('[data-yoome-header]')
      ? context
      : context.querySelector('[data-yoome-header]');
    initHeader(header);
    initMobileMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
